import { Outlet, createRootRoute, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";

import { useViewportResize } from "@/shared/stores/viewport.store";
import { companyRoute } from "./company/route";
import { homeRoute } from "./home/route";
import { loginRoute } from "./login/route";
import { pricingRoute } from "./pricing/route";
import { resetPasswordRoute } from "./reset-password/route";
import { signupRoute } from "./signup/route";
import { verifyRoute } from "./verify/route";
import { oauthSolapiRoute } from "./oauth-solapi/route";
import { oauthSolapiResultRoute } from "./oauth-solapi-result/route";
import { oauthGoogleConnectRoute } from "./oauth-google-connect/route";
import { workflowIdDashboardRoute } from "./workflow/$id/dashboard/route";
import { workflowIdIndexRoute, workflowIdRoute } from "./workflow/$id/route";
import { legalRoute } from "./legal/route";
import { workflowIdUpdateRoute } from "./workflow/$id/update/route";
import { workflowNewRoute } from "./workflow/new/route";
import { workflowIndexRoute, workflowRoute } from "./workflow/route";

const Root = () => {
	const pathname = useRouterState({ select: (state) => state.location.pathname });

	useViewportResize();

	useEffect(() => {
		const scrollRoot = document.getElementById("root");
		if (scrollRoot) {
			scrollRoot.scrollTo({ top: 0, left: 0, behavior: "auto" });
			return;
		}
		window.scrollTo({ top: 0, left: 0, behavior: "auto" });
	}, [pathname]);

	return <Outlet />;
};

export const rootRoute = createRootRoute({
	component: Root,
});

export const routeTree = rootRoute.addChildren([
	homeRoute,
	companyRoute,
	pricingRoute,
	legalRoute,
	loginRoute,
	signupRoute,
	resetPasswordRoute,
	verifyRoute,
	oauthSolapiRoute,
	oauthSolapiResultRoute,
	oauthGoogleConnectRoute,
	workflowRoute.addChildren([
		workflowIndexRoute,
		workflowNewRoute,
		workflowIdRoute.addChildren([
			workflowIdIndexRoute,
			workflowIdDashboardRoute,
			workflowIdUpdateRoute,
		]),
	]),
]);
